import { ChangeDetectionStrategy, Component, SecurityContext } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
    selector: 'entity-rich-text-renderer',
    template: ` <div class="rich-text" [innerHTML]="value"></div> `,
    styleUrls: ['./rich-text-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RichTextRendererComponent implements ICellRendererAngularComp {
    value: any;

    constructor(private sanitizer: DomSanitizer) {}

    agInit(params: ICellRendererParams): void {
        this.value = this.sanitizer.sanitize(SecurityContext.HTML, params.getValue?.() ?? null);
    }

    refresh(params: ICellRendererParams): boolean {
        this.value = this.sanitizer.sanitize(SecurityContext.HTML, params.getValue?.() ?? null);
        return true;
    }
}
